const formatAsHttps = url =>
  (url.match(/^theknot.com|\.theknot.com|[/]{2}theknot.com/)
    ? `https://${url.replace(/^https?:?\/\//, '')}`
    : url
  ).replace('www.www.', 'www.');

export default formatAsHttps;
